// import IntroIcon1 from "../../../components/ui/pngicons/intro-item-1.png";
import IntroIcon2 from "../../../components/ui/pngicons/intro-item-2.png";
import IntroIcon3 from "../../../components/ui/pngicons/intro-item-3.png";
import teamTrustLogo from "../../../assets/images/team-trust-logo.png";
import DotsPattern from "../../../components/ui/icons/DotsPattern";

import { useProfile } from "../../auth/hooks/useProfile";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import RapidTrustInsights from "../pages/RapidTrustInsights";
import StressInsightsSection from "../pages/StressInsightsSection";
import IndividualResultsFooter from "../pages/IndividualResultsFooter";
import { useLocation } from "react-router-dom";
import type { TeamMemberScore } from "../../TeamcompositeResults/api/team.api";



const pageStyle = {
  width: "100%",
  background: "white",
  padding: "40px 60px",
  boxSizing: "border-box" as const,
};

const pageBreak = {
  pageBreakAfter: "always" as const,
};


interface Props {
  teamMembers?: TeamMemberScore[];
}

const PrintIndividualResults: React.FC<Props> = ({ teamMembers }) => {
  const { user } = useProfile();
  const { currentOrganization } = useSelector(
    (state: RootState) => state.organization,
  );
  const location = useLocation();

  const selectedUser = location.state?.user;
  const clickedTeamId = location.state?.teamId;
  const clickedTeamName = location.state?.teamName;
  const isTeamResult = !!clickedTeamId;

  const logo = currentOrganization?.image || teamTrustLogo;

  const displayName = selectedUser
    ? `${selectedUser.first_name} ${selectedUser.last_name}`
    : clickedTeamId
      ? `${clickedTeamName} Team`
      : `${user?.first_name} ${user?.last_name}`;

  return (
    <div>
      {/* PAGE 1 */}
      <div style={{ ...pageStyle, ...pageBreak }}>
        <div style={{ textAlign: "center", marginTop: "60px" }}>
          <DotsPattern />

          <img
            src={logo}
            alt="Insights for Teams"
            className="relative z-10 w-[420px] mx-auto"
          />
        </div>

        <div style={{ marginTop: "100px" }}>
          <p style={{ fontSize: "22px", color: "#2a2e6e" }}>
            {displayName}
          </p>

          <h1
            style={{
              fontSize: "28px",
              fontWeight: 600,
              color: "#2a2e6e",
              marginTop: "10px",
            }}
          >
            Team Trust Accelerator Results
          </h1>
        </div>
      </div>

      {/* PAGE 2 */}
      <div style={{ ...pageStyle, ...pageBreak }}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div>
            <h2 style={{ fontSize: "22px", color: "#26295e" }}>
              {isTeamResult ? "Team Results" : "Individual Results"}
            </h2>

            <div
              style={{
                width: "40px",
                height: "3px",
                background: "#7365FF",
                marginTop: "8px",
              }}
            />
          </div>

          <img src={logo} alt="Insights for Teams" className="w-[140px]" />
        </div>

        <h1 className="text-[36px] font-bold text-[#2a2e6e] leading-tight mb-10">
          {displayName}, Team Trust Accelerator Results
        </h1>

        <p className="text-[#6b7394] text-[18px] mb-14">
          Within this report you’ll find:
        </p>

        <div className="space-y-14 text-[#6b7394] text-[16px] leading-relaxed">
          {/* <div className="flex gap-6 items-start">
            <img src={IntroIcon1} alt="" className="w-14 h-14 mt-1" />
            <p>
              Your team style preference: relational or structural. Every team
              needs individuals who have a relational, people-orientation and a
              structural, process-orientation. This report will identify which
              style is more comfortable to you.
            </p>
          </div> */}

          <div className="flex gap-6 items-start">
            <img src={IntroIcon2} alt="" className="w-14 h-14 mt-1" />
            <p>
              Social Needs for Rapid Trust Building: everyone has a different
              set of social needs that must be met to build trust with a team.
              This report will identify which social needs are most important to
              you.
            </p>
          </div>

          <div className="flex gap-6 items-start">
            <img src={IntroIcon3} alt="" className="w-14 h-14 mt-1" />
            <p>
              Unprofessional Stress Response: when under stress, threat, or
              pressure, everyone has a response that feels unprofessional to
              teammates. This report will identify your stress responses that
              are most likely to harm your team’s performance.
            </p>
          </div>
        </div>

        <div className="flex justify-between items-center mt-auto text-[12px] text-[#6b7394] pt-16">
          <p>https://goodleadership.subhostingdev.com/individual-results</p>

          <p>2/30</p>
        </div>
      </div>

      {/* PAGE 3+ */}
      <div style={pageBreak}>
        <RapidTrustInsights isPrint passedMembers={teamMembers} />
      </div>

      <div style={pageBreak}>
        <StressInsightsSection isPrint />
      </div>

      <IndividualResultsFooter />
    </div>
  );
};

export default PrintIndividualResults;
